import { Heart, Users } from "lucide-react";

export const EventsSection = () => {
  return (
    <section
      id="events"
      className="py-20 md:py-32 px-6 md:px-12 lg:px-24 bg-[#FDFBF7] grain-overlay"
      data-testid="events-section"
    >
      <div className="max-w-7xl mx-auto relative z-10">
        {/* Section Header */}
        <div className="text-center max-w-3xl mx-auto mb-16 space-y-4">
          <p className="text-sm tracking-widest uppercase font-semibold text-orange-700">
            Reliable. Thoughtful. Delicious.
          </p>
          <h2 className="font-heading text-4xl md:text-5xl font-semibold tracking-tight text-gray-800">
            Catering for Life's Moments — Big and Small
          </h2>
          <p className="text-lg md:text-xl leading-relaxed text-gray-600 pt-4">
            Whether you're hosting an intimate family celebration or a large-scale event, Kamaliicious brings warmth, organization, and exceptional flavor to the table. Our menus are customized to your occasion, guest preferences, and service style — without ever losing the feeling of home.
          </p>
        </div>

        {/* Two Column Cards */}
        <div className="grid md:grid-cols-2 gap-8">
          {/* Small Events */}
          <div className="group bg-white rounded-2xl overflow-hidden shadow-sm hover:shadow-xl transition-shadow duration-500 border border-stone-100">
            <div className="aspect-[16/10] overflow-hidden">
              <img
                src="https://images.unsplash.com/photo-1530103862676-de8c9debad1d?crop=entropy&cs=srgb&fm=jpg&q=85"
                alt="Intimate family celebration with decorated table"
                className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700"
              />
            </div>
            <div className="p-8 space-y-4">
              <div className="w-12 h-12 rounded-full bg-orange-100 flex items-center justify-center">
                <Heart className="w-6 h-6 text-orange-700" />
              </div>
              <h3 className="font-heading text-2xl md:text-3xl font-semibold text-gray-800">
                Small Events
              </h3>
              <p className="text-lg text-gray-600 leading-relaxed">
                Perfect for birthdays, home gatherings, pujas, and milestone moments where comfort and quality matter most.
              </p>
              <div className="pt-4 flex flex-wrap gap-2">
                {["Birthdays", "Pujas", "Family Dinners", "Anniversaries"].map((tag) => (
                  <span
                    key={tag}
                    className="px-4 py-2 bg-stone-100 text-sm font-medium text-gray-700 rounded-full"
                  >
                    {tag}
                  </span>
                ))}
              </div>
            </div>
          </div>

          {/* Large Events */}
          <div className="group bg-white rounded-2xl overflow-hidden shadow-sm hover:shadow-xl transition-shadow duration-500 border border-stone-100">
            <div className="aspect-[16/10] overflow-hidden">
              <img
                src="https://images.unsplash.com/photo-1767050190883-29d644fa5b99?crop=entropy&cs=srgb&fm=jpg&q=85"
                alt="Elegant wedding table setting with candles"
                className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700"
              />
            </div>
            <div className="p-8 space-y-4">
              <div className="w-12 h-12 rounded-full bg-green-100 flex items-center justify-center">
                <Users className="w-6 h-6 text-green-700" />
              </div>
              <h3 className="font-heading text-2xl md:text-3xl font-semibold text-gray-800">
                Large Events
              </h3>
              <p className="text-lg text-gray-600 leading-relaxed">
                Ideal for community celebrations, corporate parties, and high-volume events requiring seamless execution and consistent flavor at scale.
              </p>
              <div className="pt-4 flex flex-wrap gap-2">
                {["Weddings", "Corporate Events", "Community Gatherings", "Festivals"].map((tag) => (
                  <span
                    key={tag}
                    className="px-4 py-2 bg-stone-100 text-sm font-medium text-gray-700 rounded-full"
                  >
                    {tag}
                  </span>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default EventsSection;
